import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Mail, Newspaper, FileText, FolderOpen, Users, Handshake } from 'lucide-react';
import { contactAPI, newsletterAPI, blogAPI, projectsAPI, teamAPI, partnersCustomersAPI } from '../../services/api';

const DashboardOverview = () => {
  const [stats, setStats] = useState({ contacts: 0, newsletters: 0, blogs: 0, projects: 0, team: 0, partners: 0 });

  const loadStats = useCallback(async () => {
    const [c, n, b, p, t, pc] = await Promise.allSettled([
      contactAPI.getAll(), newsletterAPI.getAll(), blogAPI.getAll(),
      projectsAPI.getAll(), teamAPI.getAll(), partnersCustomersAPI.getAll()
    ]);
    setStats({
      contacts: c.status === 'fulfilled' ? (c.value.data?.length || 0) : 0,
      newsletters: n.status === 'fulfilled' ? (n.value.data?.length || 0) : 0,
      blogs: b.status === 'fulfilled' ? (b.value.data?.length || 0) : 0,
      projects: p.status === 'fulfilled' ? (p.value.data?.length || 0) : 0,
      team: t.status === 'fulfilled' ? (t.value.data?.length || 0) : 0,
      partners: pc.status === 'fulfilled' ? (pc.value.data?.length || 0) : 0,
    });
  }, []);

  useEffect(() => { loadStats(); }, [loadStats]);

  const cards = [
    { label: 'Contact Messages', value: stats.contacts, icon: Mail, color: 'text-blue-600 bg-blue-50' },
    { label: 'Newsletter Subs', value: stats.newsletters, icon: Newspaper, color: 'text-purple-600 bg-purple-50' },
    { label: 'Blog Posts', value: stats.blogs, icon: FileText, color: 'text-orange-600 bg-orange-50' },
    { label: 'Projects', value: stats.projects, icon: FolderOpen, color: 'text-emerald-600 bg-emerald-50' },
    { label: 'Team Members', value: stats.team, icon: Users, color: 'text-indigo-600 bg-indigo-50' },
    { label: 'Partners/Customers', value: stats.partners, icon: Handshake, color: 'text-teal-600 bg-teal-50' },
  ];

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="dashboard-stats">
        {cards.map(c => (
          <Card key={c.label}>
            <CardContent className="flex items-center gap-4 py-5">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${c.color}`}>
                <c.icon className="w-6 h-6" />
              </div>
              <div>
                <p className="text-sm text-gray-500">{c.label}</p>
                <p className="text-2xl font-bold text-gray-900" data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, '-')}`}>{c.value}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default DashboardOverview;
